export const FETCH_SITE_CONFIG = 'FETCH_SITE_CONFIG'
export const FETCH_SITE_CONFIG_SUCCESS = 'FETCH_SITE_CONFIG_SUCCESS'
